const INVALD_PROPS = ["color", "active", "isActive", "shouldBeExpandable", "isMobile", "collapsed", "isSelected", "disabled", "elevated", "disablepadding", "variant", "icon", "turnBorderColor", "turn", "maxWidth", "gap", "accentColor", "isSmall"];
function isStyledValidProp(prop) {
  const includeProp = INVALD_PROPS.includes(prop);
  return !includeProp;
}
export {
  isStyledValidProp
};
//# sourceMappingURL=is-styled-valid-prop.es.js.map
